const AnotherLifeModelList = () => import(/* webpackChunkName 'AnotherLifeModelList' */ '@/components/Astrology/AnotherLife/AnotherLifeModel/AnotherLifeModelList/AnotherLifeModelList.vue');
const AnotherLifeResultList = () => import(/* webpackChunkName 'AnotherLifeResultList' */ '@/components/Astrology/AnotherLife/AnotherLifeResult/AnotherLifeResultList/AnotherLifeResultList.vue');

export default {
    path: 'another-life',
    name: 'Another Life',
    redirect: 'another-life-result/',
    meta: {
        label: 'Another Life'
    },
    component: {
        name: 'AnotherLife',
        render(c: any) {
            return c('router-view');
        }
    },
    children: [
        {
            path: 'another-life-model',
            name: 'another_life_model',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Model'
            },
            component: AnotherLifeModelList
        },
        {
            path: 'another-life-result',
            name: 'another_life_result',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Result'
            },
            component: AnotherLifeResultList
        }
    ]
};